import { VIDEO_TYPE_RECIBIDOS } from "../types";

const VideoTypeReducer = (state, { type, payload }) => {
  switch (type) {
    case VIDEO_TYPE_RECIBIDOS: {
      return { ...state, video_types: payload };
    }
    default:
      return { ...state };
  }
};

export default VideoTypeReducer;